import { ChevronLeft, ExternalLink } from "lucide-react";

type WhatsAppPreviewProps = {
  appName: string;
  ctaLabels?: string[];
  message: string;
  description?: string;
};

export function WhatsAppPreview({
  appName,
  ctaLabels = [],
  message,
  description = "Prévia ilustrativa de um template. O envio real exige template aprovado pela Meta.",
}: WhatsAppPreviewProps) {
  return (
    <aside className="rounded-xl border border-slate-200 bg-white p-5">
      <h2 className="mb-4 text-base font-bold">Prévia no WhatsApp</h2>
      <div className="mx-auto w-full max-w-[285px] rounded-[30px] border-[7px] border-slate-800 bg-[#eeeae0] pb-10 shadow-sm">
        <div className="flex items-center gap-2 rounded-t-[22px] bg-emerald-700 px-3 py-3 text-white">
          <ChevronLeft size={15} />
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/25 text-xs">
            {appName.charAt(0).toUpperCase()}
          </span>
          <span>
            <strong className="block text-[11px]">{appName}</strong>
            <small className="block text-[8px] text-emerald-100">
              Conta comercial
            </small>
          </span>
        </div>
        <div className="m-3 mt-5 whitespace-pre-wrap rounded-xl bg-white p-4 text-[11px] leading-5 text-slate-700 shadow-sm">
          {message}
        </div>
        {ctaLabels.length > 0 && (
          <div className="mx-3 -mt-3 overflow-hidden rounded-b-xl bg-white text-[10px] font-bold text-emerald-600">
            {ctaLabels.map((ctaLabel, index) => (
              <div
                className={`flex items-center justify-center gap-1 py-3 ${index > 0 ? "border-t border-slate-200" : ""}`}
                key={`${ctaLabel}-${index}`}
              >
                {ctaLabel} <ExternalLink size={10} />
              </div>
            ))}
          </div>
        )}
      </div>
      <p className="mx-auto mt-4 max-w-[285px] rounded-xl border bg-slate-50 p-4 text-[11px] leading-5 text-slate-500">
        {description}
      </p>
    </aside>
  );
}
